import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds/components/icon";
import {
  StyledSectionHeaderWrapper,
  StyledSectionHeaderClickable,
  StyledSectionItemContainerLeft,
  StyledSectionItemContainerRight,
} from "@/components/layout/components/sidebar/sidebar-section/sidebar-section.styles";
import { SidebarSectionHeaderSlotName } from "@/components/layout/components/sidebar/sidebar-section/sidebar-section.types";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { getSlot } from "@/mds/utils/slots";
import styled from "@emotion/styled";
import { ReactNode, useState } from "react";
import { ButtonProps } from "react-aria-components";

interface SidebarSectionHeaderProps extends Exclude<ButtonProps, "children"> {
  defaultIconKind: MDSIconKind;
  label: string;
  children?: ReactNode;
  isExpanded: boolean;
  isDisabled?: boolean;
}

export const SidebarSectionHeader = ({
  defaultIconKind,
  label,
  isExpanded,
  ...props
}: SidebarSectionHeaderProps) => {
  const rightButtons = getSlot(props.children, SidebarSectionHeaderSlotName.ButtonsRight);
  const [isHovered, setIsHovered] = useState(false);
  const iconKind = isExpanded
    ? MDSIconKind.CaretDown
    : isHovered
      ? MDSIconKind.CaretRight
      : defaultIconKind;

  return (
    <StyledSectionHeaderWrapper
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <StyledSectionHeaderClickable {...props}>
        <StyledSectionItemContainerLeft>
          <StyledSectionHeaderIcon kind={iconKind} color={MDSIconColor.Secondary} size={12} />
          <MDSText
            variant={MDSTextVariant.TextXs}
            weight={MDSTextWeight.SemiBold}
            color={MDSTextColor.Secondary}
          >
            {label}
          </MDSText>
        </StyledSectionItemContainerLeft>
      </StyledSectionHeaderClickable>
      {rightButtons && (
        <StyledSectionItemContainerRight data-right-buttons>
          {rightButtons}
        </StyledSectionItemContainerRight>
      )}
    </StyledSectionHeaderWrapper>
  );
};

const StyledSectionHeaderIcon = styled(MDSIcon)`
  flex-shrink: 0;
`;
